import { useQuery } from "@tanstack/react-query";
export const createLocalesQueries = (requests, queryClient) => ({
    useListLocales: (params, options = {}) => useQuery({
        queryKey: ["locales", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listLocales(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map